import { getBasicTokenInfo } from '@/hooks/pricing/useBasicTokenInfo';
import { transformAddress } from '@/lib/asset/nativeAddressHelper';
export default async function getToAssetPrices(toAssets) {
  return Promise.all((toAssets || []).map(async asset => {
    const {
      address: tAddres
    } = transformAddress(asset.contract_address, asset.network);
    return getBasicTokenInfo(asset.network, tAddres);
  }));
}